import { render, staticRenderFns } from "./Charity.vue?vue&type=template&id=575bc867&scoped=true&"
import script from "./Charity.vue?vue&type=script&lang=ts&"
export * from "./Charity.vue?vue&type=script&lang=ts&"
import style0 from "./Charity.vue?vue&type=style&index=0&id=575bc867&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575bc867",
  null
  
)

export default component.exports